export default __webpack_public_path__ + "static/ak-cached/24h/media/non_seamless_header-move.25ac0f62.jpg";